/**
 * NVseArticlePage - styles
 */

import styled from 'styled-components';
import { px2rem } from 'theme/utils';

export const Div = styled.div``;

export const TopImage = styled.img`
	width: 100%;
	object-fit: cover;
	max-height: 640px;
`;

interface PageTypeProp {
	pageTypeName: string;
}
export const ContentBlockModelWrapper = styled.div<PageTypeProp>`
	max-width: 1132px;
	margin: 0 auto;
	padding: 0
		${(prop) => (prop.pageTypeName == 'NVseEventPage' ? '0' : '1rem')};
`;
